import "../scss/style.scss";
import "./contactFormHandler.js";
import { initPartnersSlider } from "./partnersSlider.js";

document.addEventListener("DOMContentLoaded", () => {
  initPartnersSlider();
});
